<template>
   <b-modal v-model="show" size="lg" title="КАДАСТР МАЪЛУМОТЛАРИ">
       <div class="container-fluid">
           <div class="row">
               <div class="col-12" style="overflow: scroll;max-height: 600px">
                   <div class="table-responsive">
                     <div class="table-wrapper">
                       <table class="table" v-if="data">
                           <tbody>
                           <tr>
                               <td>Бино номи:</td>
                               <td></td>
                               <td></td>
                           </tr>
                           <tr>
                               <td>Умумий майдони:</td>
                               <td>{{data.PloshadZU}}</td>
                               <td>PloshadZU</td>
                           </tr>
                           <tr>
                               <td>Умумий қурилиш ости майдони:</td>
                               <td>{{data.PloshadZastroyka}}</td>
                               <td>PloshadZastroyka</td>
                           </tr>
                           <tr>
                               <td>Умумий фойдали майдони:</td>
                               <td>{{data.PoleznayaPloshad}}</td>
                               <td>PoleznayaPloshad</td>
                           </tr>
                           <tr>
                               <td>Умумий яшаш майдони:</td>
                               <td>{{data.PloshadJilaya}}</td>
                               <td>PloshadJilaya</td>
                           </tr>
                           <tr>
                               <td>Вилоят:</td>
                               <td>{{data.Imya_Region.name}}</td>
                               <td>Imya_Region</td>
                           </tr>
                           <tr>
                               <td>Туман:</td>
                               <td>{{data.Imya_Rayon.name}}</td>
                               <td>Imya_Rayon</td>
                           </tr>
                           <tr>
                               <td>Манзил:</td>
                               <td>
                                   <span v-if="data.Imya_Maxalya">{{data.Imya_Maxalya}}</span>
                                   <span v-if="data.Imya_Ulitsa">,{{data.Imya_Ulitsa}}</span>
                               </td>
                               <td>
                                   <div>Imya_Maxalya</div>
                                   <div>Imya_Ulitsa</div>
                               </td>
                           </tr>
                           <tr>
                               <td>Жойлашган жойи(Местоположение):</td>
                               <td>{{data.geolocation}}</td>
                               <td>geolocation</td>
                           </tr>
                           <tr>
                               <td>Мулк тури:</td>
                               <td>
                                   <div v-if="data.VidNedvijimosti && data.VidNedvijimosti.code === 'NotResidential'">Нотурар</div>
                                   <div v-if="data.VidNedvijimosti && data.VidNedvijimosti.code === 'ResidentialIndividual'">Ҳовли жой</div>
                                   <div v-if="data.VidNedvijimosti && data.VidNedvijimosti.code === 'ResidentialMultiStorey'">Кўпқаватли</div>
                               </td>
                               <td>VidNedvijimosti</td>
                           </tr>
                           <tr>
                               <td>Уй раками:</td>
                               <td>{{data.NomerDoma}}</td>
                               <td>NomerDoma</td>
                           </tr>
                           <tr>
                               <td>Асосий бинолар:</td>
                               <td>{{data.StroeniyaOsnovnie}}</td>
                               <td>StroeniyaOsnovnie</td>
                           </tr>
                           <tr>
                               <td>Ёрдамчи бинолар:</td>
                               <td>{{data.StroeniyaVspomogatelnie}}</td>
                               <td>StroeniyaVspomogatelnie</td>
                           </tr>
                           <tr>
                               <td>Кадастр ёки баланс қиймати:</td>
                               <td>{{data.KadStoimost}}</td>
                               <td>KadStoimost</td>
                           </tr>
                           <tr>
                               <td>Қавати:</td>
                               <td>{{data.Etaji}}</td>
                               <td>Etaji</td>
                           </tr>
                           <tr>
                               <td>Мулкчилик шакли:</td>
                               <td>{{data.VidSobstvennosti.name}}</td>
                               <td>VidSobstvennosti</td>
                           </tr>
                           <tr>
                               <td>Эгалик:</td>
                               <td>{{data.Dolya}}</td>
                               <td>Dolya</td>
                           </tr>
                           <tr>
                               <td>Бино девори:</td>
                               <td>{{data.wall}}</td>
                               <td>wall</td>
                           </tr>
                           <tr>
                               <td>Зилзилага бардошлийлиги:</td>
                               <td>{{data.earthquakePoint}}</td>
                               <td>earthquakePoint</td>
                           </tr>
                           <tr>
                               <td>Коммуникация:</td>
                               <td>
                                   <template v-if="data.communication">
                                       <div v-for="c in data.communication" :key="c.code">
                                           <span v-if="c.code === 'gas' && c.name">Газ</span>
                                           <span v-if="c.code === 'VodaXol' && c.name">Сув</span>
                                           <span v-if="c.code === 'VodaGor' && c.name">Иссик сув</span>
                                           <span v-if="c.code === 'kanalizaciya' && c.name">Канализация</span>
                                           <span v-if="c.code === 'electricity' && c.name">Электр</span>
                                       </div>

                                   </template>
                               </td>
                               <td>communication</td>
                           </tr>
                           <tr>
                               <td>Бино тақиқда ёки тақиқда эмаслиги:</td>
                               <td>
                                   <span v-if="data.injunction">Тақиқ қуйилган</span>
                                   <span v-if="!data.injunction">Тақиқ йўқ</span>
                               </td>
                               <td>injunction</td>
                           </tr>
                           <tr>
                               <td>Лифт:</td>
                               <td>
                                   <span v-if="data.elevator">Бор</span>
                                   <span v-if="!data.elevator">Йўқ</span>
                               </td>
                               <td>elevator</td>
                           </tr>
                           <tr>
                               <td>Объект ҳажми:</td>
                               <td>{{data.objectVolume}}</td>
                               <td>objectVolume</td>
                           </tr>
                           <tr>
                               <td>Қурилган йили:</td>
                               <td>{{data.GodPostroyki}}</td>
                               <td>GodPostroyki</td>
                           </tr>
                           <tr>
                               <td colspan="3" class="text-center" style="font-weight: bold">Бинолар</td>
                           </tr>
                           <tr>
                               <td colspan="3">
                                   <div class="table-responsive" v-if="data.items && data.items.length > 0">
                                     <div class="table-wrapper">
                                       <table class="customers" v-for="(b ,index) in data.items" :key="index">
                                           <span style="font-weight: bold">#{{index + 1}}</span>
                                           <tr>
                                               <td>Бино номи:</td>
                                               <td>{{b.Naimenovanie}}</td>
                                               <td>Naimenovanie</td>
                                           </tr>
                                           <tr>
                                               <td>Қавати:</td>
                                               <td>{{b.Etajnost}}</td>
                                               <td>Etajnost</td>
                                           </tr>
                                           <tr>
                                               <td>Баландлиги:</td>
                                               <td>{{b.Visota}}</td>
                                               <td>Visota</td>
                                           </tr>
                                           <tr>
                                               <td>Қурилиш ости майдони:</td>
                                               <td>{{b.PloshadZastroyka}}</td>
                                               <td>PloshadZastroyka</td>
                                           </tr>
                                           <tr>
                                               <td>Фойдали майдони:</td>
                                               <td>{{b.PloshadPoleznaya}}</td>
                                               <td>PloshadPoleznaya</td>
                                           </tr>
                                           <tr>
                                               <td>Бино девори:</td>
                                               <td>{{b.wall}}</td>
                                               <td>wall</td>
                                           </tr>
                                           <tr>
                                               <td>Қурилган йили:</td>
                                               <td>{{b.GodPostroyki}}</td>
                                               <td>GodPostroyki</td>
                                           </tr>
                                       </table>
                                     </div>
                                   </div>
                               </td>
                           </tr>
                           </tbody>
                       </table>
                     </div>
                   </div>
               </div>
           </div>
       </div>
       <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
           <button class="all-btn float-right mr-2" @click="show =!show">
               Чиқиш
           </button>
       </div>
   </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    export default {
        name: "CadastreHistoricalViewModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                data: null
            }
        },
        created() {
            this.$eventBus.$on("showCadastreHistoricalViewModal", (data) => {
                if (data && data.cadastreApiData) {
                    this.data = data.cadastreApiData;
                }
                this.show = true
            })
        }
    }
</script>

<style scoped>

</style>